import JsComponent from '../jsComponent/jsComponent.js';
import Sticky from '../../utilities/js/sticky/sticky.js';
import _debounce from 'lodash/debounce';
import scrollTo from 'scroll-to';

const defaultOptions = {
  topOffset: 100
};

class GoTop extends JsComponent {
  constructor(mainElement, name = 'go-top', options) {
    super(mainElement, name);
    this.mainElement = mainElement;
    this.createClassNames(
      '--sticky'
    );

    this.isSticky = false;
    this.options = Object.assign({}, defaultOptions, options);
    this.bindEvents();
    Sticky(this.mainElement);
  }

  bindEvents() {
    const scrollListener = _debounce(this.handleScroll.bind(this));
    window.addEventListener('scroll', scrollListener, { passive: true });

    this.mainElement.addEventListener('click', (evt) => {
      evt.preventDefault();
      scrollTo(0, 0, {duration: 500});
    });
  }

  handleScroll() {
    this.toggleSticky(window.pageYOffset > this.options.topOffset);
  }

  toggleSticky(isSticky) {
    this.isSticky = isSticky === undefined ? !this.isSticky : isSticky;
    this.mainElement.classList.toggle(this.classNames.sticky, isSticky);
  }
}

export default GoTop;
